import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Icon } from 'panamera-react-ui';
import Bundle from "../../Components/Bundle/Bundle";
import DependencyManager from "../../DependencyManager";
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
import { compose } from 'redux';
import TitleComponent from "../../Components/Title/Title";
import { Link } from 'react-router-dom';
import withConfig from "../../ComponentDependency/withConfig";
var SLIDES_TO_SHOW_DESKTOP = 6;
var SLIDES_TO_SHOW_MOBILE = 2;
export var HomePageBundleContainer = function HomePageBundleContainer(_ref) {
  var data = _ref.data,
    metadata = _ref.metadata,
    name = _ref.name,
    onItemView = _ref.onItemView,
    track = _ref.track,
    config = _ref.config;
  var _ref2 = metadata || {},
    style = _ref2.style;
  var apiUrl = data.apiUrl,
    bundleType = data.bundleType,
    apiParams = data.apiParams,
    showAllUrl = data.showAllUrl,
    tagImage = data.tagImage,
    _data$hideViewAllCard = data.hideViewAllCard,
    hideViewAllCard = _data$hideViewAllCard === void 0 ? true : _data$hideViewAllCard,
    _data$showTagInFirstC = data.showTagInFirstCard,
    showTagInFirstCard = _data$showTagInFirstC === void 0 ? true : _data$showTagInFirstC,
    title = data.title,
    subtitle = data.subtitle,
    topIcon = data.topIcon,
    _data$showYearInVasSh = data.showYearInVasSheet,
    showYearInVasSheet = _data$showYearInVasSh === void 0 ? true : _data$showYearInVasSh,
    _data$showOlxAutosAdC = data.showOlxAutosAdCardTag,
    showOlxAutosAdCardTag = _data$showOlxAutosAdC === void 0 ? true : _data$showOlxAutosAdC,
    _data$showOriginalTit = data.showOriginalTitle,
    showOriginalTitle = _data$showOriginalTit === void 0 ? true : _data$showOriginalTit,
    _data$showSubTitle = data.showSubTitle,
    showSubTitle = _data$showSubTitle === void 0 ? true : _data$showSubTitle,
    _data$showMakeModel = data.showMakeModel,
    showMakeModel = _data$showMakeModel === void 0 ? true : _data$showMakeModel,
    _data$showSubDetails = data.showSubDetails,
    showSubDetails = _data$showSubDetails === void 0 ? true : _data$showSubDetails,
    _data$source = data.source,
    source = _data$source === void 0 ? '' : _data$source,
    _data$hideShowAllLink = data.hideShowAllLink,
    hideShowAllLink = _data$hideShowAllLink === void 0 ? true : _data$hideShowAllLink;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    hasData = _useState2[0],
    setHasData = _useState2[1];
  var isOlxMobbi = config === null || config === void 0 ? void 0 : config.get('isOlxMobbi');
  var PanameraConstants = DependencyManager.getDependency('constants');
  var IS_DEKSTOP = PanameraConstants.platform === 'desktop';
  var sliderSettings = showTagInFirstCard ? {
    responsive: null,
    variableWidth: true,
    lazyLoad: null
  } : {};
  var finalURL = (topIcon === null || topIcon === void 0 ? void 0 : topIcon.iconLink) || showAllUrl || '';
  return hasData ? /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(TitleComponent, {
    title: title
  }), subtitle && /*#__PURE__*/React.createElement(TitleComponent, {
    title: subtitle
  }), topIcon && /*#__PURE__*/React.createElement(Link, {
    to: "".concat(isOlxMobbi ? "/olxmobbi".concat(finalURL) : finalURL),
    style: topIcon === null || topIcon === void 0 ? void 0 : topIcon.inconLinkStyle
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    icon: (topIcon === null || topIcon === void 0 ? void 0 : topIcon.icon) || 'back',
    style: topIcon === null || topIcon === void 0 ? void 0 : topIcon.iconStyle,
    color: (topIcon === null || topIcon === void 0 ? void 0 : topIcon.iconColor) || 'blackText',
    direction: (topIcon === null || topIcon === void 0 ? void 0 : topIcon.iconDirection) || 'rtl'
  })), /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement(Bundle, {
    url: apiUrl,
    apiParams: apiParams,
    bundleType: bundleType,
    count: IS_DEKSTOP ? SLIDES_TO_SHOW_DESKTOP : SLIDES_TO_SHOW_MOBILE,
    showAllUrl: showAllUrl,
    widgetKey: name,
    metadata: metadata,
    onItemView: onItemView,
    showEmiPlaceHolder: false,
    showOriginalTitle: showOriginalTitle,
    showSubTitle: showSubTitle,
    showMakeModel: showMakeModel,
    showSubDetails: showSubDetails,
    showYearInVasSheet: showYearInVasSheet,
    hideShowAllLink: hideShowAllLink,
    tagImage: tagImage,
    showTagInFirstCard: showTagInFirstCard,
    source: source || 'homePageBundles',
    hideViewAllCard: hideViewAllCard,
    setHasData: setHasData,
    track: track,
    showFullPrice: true,
    showOlxAutosAdCardTag: showOlxAutosAdCardTag,
    sliderSettings: sliderSettings
  }))) : null;
};
export default compose(withConfig, withComponentDependency)(HomePageBundleContainer);